const isFirefox = typeof InstallTrigger !== "undefined";

export const scrollIntoView = (ref) => {
  if (isFirefox) {
    ref.scrollIntoView({ block: "center" });
  } else {
    ref.scrollIntoViewIfNeeded();
  }
};
